export default "__VITE_ASSET__BChLKijt__"